import React from 'react';
import Icon from '../Icon';

import arrowDownIcon from './dropdown-arrow-down.png';

export default function ArrowDownIcon(props) {
    return <Icon image={arrowDownIcon} {...props} />;
}
